import { errHandler } from "../utils/common";
import { incrementCounter } from "../utils/notificationCounter";
import api from "../utils/api";
export default class PeCases {
  getAll = (
    opt = {
      page: 1,
      limit: 10,
      searchBy: null,
      searchValue: null,
      includeRegmal: false,
    }
  ) => {
    return new Promise((resolve, reject) => {
      api
        .get("/api/pe_cases/id", { params: opt })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  getOne = (id) => {
    return new Promise((resolve, reject) => {
      api
        .get(`/api/pe_case/id/${id}`)
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };

  add = (payload) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/pe_case?device=Online", payload)
        .then(async (res) => {
          const classification = String(payload.case_classification || "");
          const increments = [];
          if (classification.includes("Import") && payload.district_id) {
            increments.push(
              incrementCounter(
                "/api/notification/incr/import-case",
                payload.district_id
              )
            );
          }
          if (classification.includes("Indigenous") && payload.district_id) {
            increments.push(
              incrementCounter(
                "/api/notification/incr/indigenous-validation",
                payload.district_id
              )
            );
          }
          await Promise.all(increments);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  update = (payload, peCasesId) => {
    return new Promise((resolve, reject) => {
      api
        .patch(`/api/pe_case/id/${peCasesId}?device=Online`, payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
  remove = (peCasesId) => {
    return new Promise((resolve, reject) => {
      api
        .delete(`/api/pe_case/${peCasesId}?device=Online`)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          errHandler(err);
        });
    });
  };
}
